import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BannerT } from "shared/types/banner";

type Banner = {
  upload?: boolean;
  notFound?: boolean;
} & Partial<BannerT>;

type BannersState = {
  banners: Record<number, Banner>;
};

const initialState: BannersState = {
  banners: {},
};

const bannersSlice = createSlice({
  name: "banners",
  initialState,
  reducers: {
    setBanner: (state, { payload }: PayloadAction<BannerT>) => {
      state.banners[payload?.place] = payload ?? {};
      state.banners[payload?.place].upload = true;
    },
    setBannerNotFound: (state, { payload }: PayloadAction<number>) => {
      state.banners[payload] = {};
      state.banners[payload].upload = true;
      state.banners[payload].notFound = true;
    },
  },
});

export const { setBanner, setBannerNotFound } = bannersSlice.actions;

export default bannersSlice.reducer;
